//the options of the user and team synchronization (setting DirectorySyncOptions): the task template started when a
//user is disabled in or removed from the directory, and whether the user's groups are added to that task
export default class DirectorySyncOptions {
  offboardingTemplateId: number | undefined;

  offboardingIncludeGroups: boolean;

  constructor() {
    this.offboardingTemplateId = undefined;
    this.offboardingIncludeGroups = true;
  }

  //a missing property reads as its default, an unparsable text as the defaults
  static fromJSON(data: string | undefined): DirectorySyncOptions {
    const options = new DirectorySyncOptions();
    if (!data) return options;

    try {
      const parsed = JSON.parse(data);
      if (typeof parsed?.offboardingTemplateId === 'number' && parsed.offboardingTemplateId > 0) {
        options.offboardingTemplateId = parsed.offboardingTemplateId;
      }
      if (typeof parsed?.offboardingIncludeGroups === 'boolean') {
        options.offboardingIncludeGroups = parsed.offboardingIncludeGroups;
      }
    } catch {
      //ignore
    }

    return options;
  }

  toJSON(): string {
    return JSON.stringify({
      offboardingTemplateId: this.offboardingTemplateId ?? null,
      offboardingIncludeGroups: this.offboardingIncludeGroups,
    });
  }

  isEqual(other: DirectorySyncOptions): boolean {
    return (
      this.offboardingTemplateId === other.offboardingTemplateId &&
      this.offboardingIncludeGroups === other.offboardingIncludeGroups
    );
  }

  clone(): DirectorySyncOptions {
    const options = new DirectorySyncOptions();
    options.offboardingTemplateId = this.offboardingTemplateId;
    options.offboardingIncludeGroups = this.offboardingIncludeGroups;

    return options;
  }
}
